module.exports = __webpack_public_path__ + "img/shouye-daili-png-02.337eabed.svg";